import styles from './FilmTitle.module.css';

//#region [Props]
type FilmTitleProps = {
	title: string;
	length?: string | null;
	genres?: string[];
	ageRating?: string;
};
//#endregion

//#region [Component]
export default function FilmTitle({ title, length, genres, ageRating }: FilmTitleProps) {
	let len = length;
	if( length && /^\d+$/.test(length) ) {
		const lenNum = Number(length);
		if( lenNum > 60) {
			len = `${Math.floor(lenNum / 60).toFixed(0)} t ${lenNum % 60} m`;
		}
	}

	return <div className={styles.STitleWrapper}>
		<h1 className={styles.SFilmTitle}>{title}</h1>
		<div className={styles.STagLine}>
			{ageRating && <div className={styles.SAgeRating} aria-label='Anbefalt aldersgrense'>{ageRating}</div>}
			{len && <div className={styles.SLength}>{len}</div>}
			<div className={styles.SGenres}>{genres?.join(" / ")}</div>
		</div>
	</div>;
}
//#endregion
